import { DateRange } from "./date";

export class Product {
    id: number;
    appCode: string;
    createdDate: string;
}

export class ProductSearch {
    createdDate: DateRange = DateRange.empty();
    type = 'mobile_no';
    id = '';
    appCode = '';
    productName='';
    merchantId='';
    locationId='';
    linkedProduct:any;
    isAvailable:boolean;
 }